import moment from 'moment';
import template from './date-range.html';

export default function DateRangeDirective() {
  return {
    restrict: 'E',
    template,
    scope: {},
    controllerAs: 'vm',
    bindToController: {
      startRange: '<',
      endRange: '<',
      minDate: '<',
      maxDate: '<',
      dateOption: '<',
      updateStartDate: '&',
      updateEndDate: '&',
      onUpdateOption: '&'
    },
    controller: DateRangeController
  };
}

export function DateRangeController($scope, gettextCatalog, dateUtil) {
  'ngInject';
  // Private Variables

  let vm = this;
  vm.timeSelected = false;

  //Time range presets for radio button
  this.timeRangePresets = [
    {
      value: 1,
      label: gettextCatalog.getString('24hrs'),
      tooltip: gettextCatalog.getString('Last 24 Hours')
    },
    {
      value: 7,
      label: gettextCatalog.getString('7d'),
      tooltip: gettextCatalog.getString('Last 7 Days')
    },
    {
      value: 30,
      label: gettextCatalog.getString('30d'),
      tooltip: gettextCatalog.getString('Last 30 Days')
    }
  ];

  vm.showTime = showTime;
  vm.openStart = openStart;
  vm.openEnd = openEnd;
  vm.selectPreset = selectPreset;
  vm.endTimeChanged = endTimeChanged;
  vm.startTimeChanged = startTimeChanged;

  //Time range picker variables
  vm.startOpened = false;
  vm.endOpened = false;
  vm.invalidStartDate = false;
  vm.invalidEndDate = false;
  vm.locale = 'en';

  //----------------------------------------------------------------------------------------------------

  // init
  vm.$onInit = init;

  function init() {
    if ($scope.$root.currentUser) {
      vm.locale = $scope.$root.currentUser.claims.data.language;
    }
    refresh();
  }
  //----------------------------------------------------------------------------------------------------

  // Public Functions
  function endTimeChanged() {
    // Checking if the endRange is a valid date
    if (vm.endRange) {
      // Checking if the user has selected the same day
      checkIfSameTime();
      vm.updateEndDate({
        endDate: vm.endRange
      });
    }
  }

  function startTimeChanged() {
    // Checking if the startRange is a valid date
    if (vm.startRange) {
      // Also checking if the user has selected the same time
      checkIfSameTime();
      vm.updateStartDate({
        startDate: vm.startRange
      });
    }
  }
  // Check if startRange and endRange are equal
  function checkIfSameTime() {
    if (moment(vm.endRange).isSame(vm.startRange, 'minute')) {
      // If they are equal, assign the startTime to begining of the day.
      // And endRange to this moment
      vm.startRange = moment()
        .startOf('day')
        .toDate();
      vm.endRange = moment()
        .startOf('minute')
        .toDate();
    }
  }
  function openStart() {
    vm.startOpened = !vm.startOpened;
  }

  function openEnd() {
    vm.endOpened = !vm.endOpened;
  }

  function showTime() {
    vm.timeSelected = !vm.timeSelected;
  }
  //------------------------------------------------------------------------------------------------------------------------------------

  function selectPreset(preset) {
    $('#btn-1').blur();
    $('#btn-7').blur();
    $('#btn-30').blur();

    vm.onUpdateOption({option: preset.value});
  }

  function refresh() {
    if (vm.startRange && vm.endRange) {
      vm.maxStartDate = vm.endRange;
      vm.minEndDate = vm.startRange;
      vm.maxEndDate = moment()
        .endOf('minute')
        .toDate();
    }
  }
}
